import React from 'react';

const PdfIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    {...props}
  >
    <path
      d="M1.33366 8.6665V8.1307C1.33366 6.15245 1.33366 5.16332 1.64628 4.37333C2.14887 3.10331 3.21175 2.10154 4.55923 1.62784C5.39741 1.33319 6.44687 1.33319 8.54578 1.33319C9.74516 1.33319 10.3448 1.33319 10.8238 1.50156C11.5938 1.77225 12.2012 2.34469 12.4883 3.07041C12.667 3.52184 12.667 4.08705 12.667 5.21748V8.00931V8.6665"
      stroke="#002564"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.33333 8C1.33333 6.7727 2.32826 5.77778 3.55556 5.77778C3.99941 5.77778 4.52269 5.85555 4.95424 5.73992C5.33768 5.63718 5.63718 5.33768 5.73992 4.95424C5.85555 4.52269 5.77778 3.99941 5.77778 3.55556C5.77778 2.32826 6.7727 1.33333 8 1.33333"
      stroke="#002564"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.33301 14.6665V12.6665M1.33301 12.6665V11.4665C1.33301 11.0894 1.33301 10.9008 1.45017 10.7837C1.56732 10.6665 1.75588 10.6665 2.13301 10.6665H2.66634C3.21863 10.6665 3.66634 11.1142 3.66634 11.6665C3.66634 12.2188 3.21863 12.6665 2.66634 12.6665H1.33301ZM12.6663 10.6665H11.6663C11.0378 10.6665 10.7235 10.6665 10.5283 10.8618C10.333 11.057 10.333 11.3713 10.333 11.9998V12.6665M10.333 14.6665V12.6665M10.333 12.6665H11.9997M8.33301 12.6665C8.33301 13.7711 7.43758 14.6665 6.33301 14.6665C6.08378 14.6665 5.95916 14.6665 5.86634 14.6129C5.64411 14.4846 5.66634 14.2249 5.66634 13.9998V11.3332C5.66634 11.1081 5.64411 10.8484 5.86634 10.7201C5.95916 10.6665 6.08378 10.6665 6.33301 10.6665C7.43758 10.6665 8.33301 11.5619 8.33301 12.6665Z"
      stroke="#002564"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PdfIcon;
